import { useState, useCallback, useMemo } from "react";
import { ContractorPanelVisitsFilters } from "../components/ContractorPanelVisitsFilter";
import { checkHasActiveFilters } from "../utils/checkHasActiveFilters";
import { applyTodayFilterChange } from "../utils/applyVisitFilterChanges";
import { INITIAL_VISIT_FILTERS } from "../constants";

export const useContractorPanelVisitFilters = () => {
  const [filters, setFilters] = useState<ContractorPanelVisitsFilters>(
    INITIAL_VISIT_FILTERS,
  );

  const hasActiveFilters = useMemo(
    () => checkHasActiveFilters(filters),
    [filters],
  );

  const clearFilters = useCallback(() => {
    setFilters({});
  }, []);

  const handleToggleTodayFilter = useCallback(() => {
    setFilters((prev) =>
      applyTodayFilterChange(prev, !prev.isTodayAndUpcoming),
    );
  }, []);

  return useMemo(
    () => ({
      filters,
      setFilters,
      clearFilters,
      hasActiveFilters,
      handleToggleTodayFilter,
    }),
    [filters, clearFilters, hasActiveFilters, handleToggleTodayFilter],
  );
};
